import * as React from 'react';
const OptionsIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3.333c-.815 0-1.482.667-1.482 1.482S9.185 6.296 10 6.296s1.482-.666 1.482-1.481S10.815 3.333 10 3.333m0 10.37c-.815 0-1.482.667-1.482 1.482s.667 1.482 1.482 1.482 1.482-.667 1.482-1.482-.667-1.481-1.482-1.481m0-5.184c-.815 0-1.482.666-1.482 1.481s.667 1.482 1.482 1.482 1.482-.667 1.482-1.482S10.815 8.519 10 8.519"
      fill="currentColor"
    />
  </svg>
);
export default OptionsIcon;
